import { DsModalConfig } from '@design-system/ds-base-modal/interfaces/ds-modal-config.interface';

/**
 * Dialog size of the service request flags modal. All callers use the same size.
 */
export const SERVICE_REQUEST_FLAGS_MODAL_CONFIG: Readonly<DsModalConfig> = {
  width: '100%',
  maxWidth: '80rem',
};
